import * as Styled from "./style";
import { LimitedPremiumDetailPriceText } from "~/components/blocks/product/common/blocks/price-with-discount-display/limited-premium-detail-price-text";
import { NormalPrice } from "~/components/blocks/product/common/blocks/price-with-discount-display/normal-price";
import type { G_GetVideoMainEpisodeQuery } from "~/lib/graphql";

export type DetailPriceTextProps = {
  priceSummary?: G_GetVideoMainEpisodeQuery["video"]["episodes"]["edges"][number]["node"]["priceSummary"];
};

/**
 * ### PPV価格表記パターンの出し分けを行うコンポーネント
 */
export const PriceWithDiscountDisplay = (props: DetailPriceTextProps) => {
  const { priceSummary } = props;
  if (!priceSummary) return null;
  const { isLimitedPremium, lowestPrice, highestPrice, discountedLowestPrice } = priceSummary;
  const isMultiPrice = lowestPrice < highestPrice;

  return (
    <Styled.DivWrapper role="note" aria-label="価格情報">
      {isLimitedPremium ? (
        <LimitedPremiumDetailPriceText
          price={lowestPrice}
          salePrice={discountedLowestPrice}
          isMultiPrice={isMultiPrice}
        />
      ) : (
        <NormalPrice price={lowestPrice} salePrice={discountedLowestPrice} isMultiPrice={isMultiPrice} />
      )}
    </Styled.DivWrapper>
  );
};

PriceWithDiscountDisplay.displayName = "PriceText";
